import {
    SectionCard,
    SectionCardH1,
    SectionCardHeading,
    SectionCardSubH1,
} from 'components/SectionCard';
import PageBar from 'components/PageBar';
import { PagePadding } from 'components/PagePadding';
import SpotlightTiles from 'components/Spotlights';
import Stack from 'components/Stack';
import { mixpanelTrack } from 'utils/app';
import { useEffect } from 'react';
import { useFetchSpotlights } from 'utils/hooks/spotlights';

const space = (theme) => `${theme.space_11}px`;

function Spotlight() {
    const { data: spotlights, status } = useFetchSpotlights();

    useEffect(() => {
        mixpanelTrack('Spotlight');
    }, []);

    return (
        <PagePadding>
            <PageBar showCountrySelect={false} />
            <Stack $space={space}>
                <SectionCard>
                    <SectionCardHeading>
                        <SectionCardH1>Spotlight.</SectionCardH1>
                        <SectionCardSubH1>
                            Spate's latest reports.
                        </SectionCardSubH1>
                    </SectionCardHeading>
                    <SpotlightTiles
                        spotlights={spotlights ? spotlights.slice(0, 2) : null}
                        status={status}
                    />
                </SectionCard>
                <SectionCard>
                    <SectionCardHeading>
                        <SectionCardH1>All Reports.</SectionCardH1>
                    </SectionCardHeading>
                    <SpotlightTiles
                        spotlights={spotlights ? spotlights.slice(2) : null}
                        status={status}
                    />
                </SectionCard>
            </Stack>
        </PagePadding>
    );
}

export default Spotlight;
